module.exports = __webpack_public_path__ + "media/customizations/simplyartavia/logo-new-d0696b843536d4f67e79a3aea152b76d.png";